import { useRef } from "react";

/**
 * Genera un identificador único y persistente para un elemento HTML.
 * 
 * El valor se calcula una sola vez por instancia del hook y se mantiene
 * estable entre renders, evitando cambios inesperados en el DOM.
 *
 * @param {string} [prefix="id"] - Prefijo opcional para el identificador.
 * @returns {string} Identificador único en formato `${prefix}-<random>`.
 *
 * @example
 * const inputId = useId("input");
 * <label htmlFor={inputId}>Nombre</label>
 * <input id={inputId} />
 */
export const useId = (prefix = "id") => {
	const idRef = useRef(null);

	if (!idRef.current) {
		idRef.current = `${prefix}-${Math.random().toString(36).slice(2, 9)}`;
	}

	return idRef.current;
};